import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { ColumnTypeIconComponent } from '@blaze-shared/shared-ui';

import { ContextValue } from '../../../../core/models/intelli-autocomplete.models';

@Component({
  selector: 'blaze-type-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, ColumnTypeIconComponent],
  templateUrl: './type-icon.component.html',
  styleUrl: './type-icon.component.scss',
})
export class TypeIconComponent {
  value = input<ContextValue | undefined>();

  columnType = computed(() => this.value()?.columnType);
  isArray = computed(() => this.value()?.isArray ?? false);

  extraIconSvgName = computed(() => {
    const value = this.value();
    if (!value || value.isArray || value.columnType) {
      return undefined;
    }
    if (value.type === 'Condition') {
      return 'node_if_16';
    }
    if (
      value.type &&
      ['Stored Variable', 'Global Variable', 'URL Parameter'].includes(value.type)
    ) {
      return 'node_assign_16';
    }
    return undefined;
  });
}
